import React from 'react'
import Logo from './../../../assets/logo.svg'
import { Link } from 'react-router-dom';
import {
    Navvo
} from './NavWidget.style'
// import Cookies from 'js-cookie';
import PickEstateBtn from '../../components/Dashboard/pick_estate_btn';
import MobileSidebarMenu from '../SidebarWidget/mobileSideBard';
import { gql } from '@apollo/client';
import CheckSubcriptionPackageWidget from '../../components/Dashboard/check_subscription';



export const FETCH_CURRENT_PLAN = gql
`
query FacilityManager {
  facilityManager {
    subscriptionData {
      subscriptionPlan
      residentCapacity
      subscriptionExpiryDate
    }
  }
}

`;

function NavWidget() {
// const [selected, setSelected] = React.useState(null)
// const accesTokenValue = Cookies.get('userAccessToken');
// const facilityIdValue = Cookies.get('facilityId');
// const { loading,error,data }  = useQuery(FETCH_CURRENT_PLAN);
// if (loading) return ;
// if (error) return <p>Error: {error.message}</p>;
  return (
    <div>
        <CheckSubcriptionPackageWidget/>
        
         <Navvo>
            <div className="nav-wrapper white z-depth-0">
                <Link to="/" className="brand-logo p-16 black-text">
                    {/* Dashboard */}
                    <div className='' style={{
                        marginLeft:"40px"
                    }}>
                        <img src={Logo} alt=''/>
                    </div>
                </Link>
                <div  data-target="mobile-demo" className="sidenav-trigger show-on-small show-on-medium hide-on-large-only">
                    <MobileSidebarMenu/>
                </div>
                <ul className="center ">
                    <PickEstateBtn/>
                </ul>
            </div>
        </Navvo>
                    
    </div>
  )
}

export default NavWidget